import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { Feedback } from './views/Feedback';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<Feedback />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Feedback)
	.build();

export default Layout;
